export const AUTH_TOKEN = 'auth_token';

// session storage variables

export const USER_AUTHENTICATION_TOKEN = 'edu-web-auth-token';
export const LOGGED_IN_USER_ID = 'edu-web-logged-in-user-id';
export const LOGGED_IN_USER_NAME = 'edu-web-logged-in-user-name';
export const CLIENT_ID = 'edu-web-client-id';
export const ROLE_ID = 'edu-web-role-id';

